import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { PermissionService } from '../services/permission.service';
import { UserService } from '../user/user.service';

export const permissionGuard =
   (requiredPermission: string): CanActivateFn =>
   () => {
      const permissionService = inject(PermissionService);
      const userService = inject(UserService);
      const router = inject(Router);

      return permissionService.hasPermission(requiredPermission).pipe(
         take(1),
         map((hasPermission) => {
            const user = userService.currentUser$.value;

            if (user && !user.storeId) {
               router.navigate(['/store']);
               return false;
            }

            if (!hasPermission) {
               console.warn(
                  `[PermissionGuard] Denied: ${requiredPermission} | role: ${user?.storeRole}`,
               );
               return router.parseUrl('/access-denied');
            }

            return true;
         }),
      );
   };
